// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"c03901e6","102":"cecf74ea","325":"7951181c","405":"91f1cd16","458":"ebd9d336","477":"2288b8c4","710":"3f84399f","739":"80475dd9","818":"5ec2ea99","865":"e29d3b16","912":"6217fda2","944":"da726481"}[chunkId] + ".chunk.js";
};